import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19162a8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawing-animation" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "sizing" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 結果を見る ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 戻る ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButtonPrimary = _resolveComponent("AppButtonPrimary")!
  const _component_AppButtonSecondary = _resolveComponent("AppButtonSecondary")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", { src: _ctx.drawingAnimationUrl }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppButtonPrimary, {
        "is-disabled": !_ctx.hasPrizeBeenWon,
        onButton: _ctx.seePrize
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["is-disabled", "onButton"]),
      _createVNode(_component_AppButtonSecondary, { onButton: _ctx.goBack }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onButton"])
    ])
  ]))
}